module.exports = __webpack_public_path__ + "img/stat-1-icon.20ab7313.svg";